import { Card, message, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API } from "../../config/api";
import { POST } from "../../utils/apicalls";
import PageHeader from "../../admin/pageHeader/pageheader";
import moment from "moment";

function TaskDetails() {
  const [isLoading, setIsLoading] = useState(false);
  const [taskData, setTaskData] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(1500); // Initial page size
  const { id } = useParams();

  useEffect(() => {
    fetchTaskData();
  }, [page, pageSize]);

  const fetchTaskData = async () => {
    try {
      setIsLoading(true);
      const obj = {
        query: "string",
        page: page,
        take: pageSize,
        Projectid: Number(id),
      };
      const url = API.TASK_IN_PROJECT;
      const response: any = await POST(url, obj);

      if (response?.data) {
        setTaskData(response?.data); // Set the fetched data
      } else {
        setTaskData([]);
      }
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch task data. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      dataIndex: "TaskName",
      title: "Task Name",
    },
    {
      dataIndex: "descriptions",
      title: "Description",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status: string) => {
        let color = "";

        // Assign colors based on the status value
        switch (status?.toLowerCase()) {
          case "completed":
            color = "green";
            break;
          case "pending":
            color = "orange";
            break;
          case "in-progress":
            color = "purple";
            break;
          default:
            color = "black"; // Default color
        }
        return <span style={{ color, fontWeight: "bold" }}>{status}</span>;
      },
    },
    {
      dataIndex: "startDates",
      title: "startDates",
      render: (date: any) => (date ? moment(date).format("DD/MM/YYYY") : "-"),
    },
    {
      dataIndex: "endDates",
      title: "endDates",
      render: (date: any) => (date ? moment(date).format("DD/MM/YYYY") : "-"),
    },
  ];
  console.log("total task", taskData.length);
  return (
    <div>
      <PageHeader />
      <Card>
        <h1 style={{ textAlign: "center" }}>TOTAL TASKS: {taskData?.length}</h1>
        <Table
          columns={columns}
          dataSource={taskData}
          pagination={{
            current: page,
            pageSize: pageSize,
            total: taskData?.length,
            onChange: (page: any, pageSize: any) => {
              setPage(page);
              setPageSize(pageSize);
            },
          }}
        />
      </Card>
    </div>
  );
}

export default TaskDetails;
